import BoxZoomTool from '~/components/toolbar/tools/BoxZoomTool';
import PanTool from '~/components/toolbar/tools/PanTool';
import ResetViewTool from '~/components/toolbar/tools/ResetViewTool';

export default function DefaultTools() {
    return (
        <>
            <PanTool />
            <BoxZoomTool />
            <ResetViewTool />
        </>
    );
}
